/*
 * RulesPage
 *
 * List all the Rules
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    changeSearchStatus,
    changeProfileTabValue
} from '../../modules/user';
import { Link } from 'react-router-dom';
import AppBar from 'material-ui/AppBar';
import Tabs, { Tab } from 'material-ui/Tabs';
import Table, {
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from 'material-ui/Table';
import BookmarkBorderIcon from 'material-ui-icons/BookmarkBorder';
import GuideTopImgSrc from '../../assets/images/RulesPage/rules_guide_top.svg';
import DialogDecorationImgSrc from '../../assets/images/RulesPage/rules_guide_dialog_decoration.png';
import BookImgSrc from '../../assets/images/Profile/book.png';
import Paper from 'material-ui/Paper';
import get from 'lodash/get';
import ErrorBoundary from '../../components/ErrorBoundary';
import './RulesPage.css';


const rulesData = {
    rules: [
        {
            number: '1',
            content: 'The Challenge opens on Monday 23 February 2026. You must complete your online Student Reading Record by Friday 18 September 2026 (11:59 pm) to complete the Challenge.'
        },
        {
            number: '2',
            content: 'You must read a certain number of books to complete the Challenge:'
        },
        {
            number: '3',
            content: 'Books you read after the Challenge closes can count towards the next year\'s Challenge.'
        },
        {
            number: '4a',
            content: 'K-2 and 3-10 challenges: you can read books on your own, read them with someone else, or someone can read them to you.'
        },
        {
            number: '4b',
            content: '3-4, 5-6 and 7-10 challenges: you are expected to read your books independently. However, with teacher approval, texts read aloud or shared in class may count towards your Challenge. Your teachers will guide and approve which texts read in class can be counted this way..'
        },
        {
            number: '5',
            content: 'In an approved series on the PRC booklist, you can read any five books as PRC books. You can read up to ten other books from the same series as Personal Choice books.'
        },
        {
            number: '6a',
            content: 'K-2 Challenge: you can read books or have them read to you in your home language.'
        },
        {
            number: '6b',
            content: '3-4, 5-6, 7-10 Challenge: you must read all PRC books in English. You may read Personal Choice books in your home language.'
        },
        {
            number: '7a',
            content: 'K-2 students only - If you can read simple chapter books on your own, you can attempt the 3-4 Challenge. You need to get your Student Reading Record changed to Challenge level 3-4. See your PRC coordinator for help with this.'
        },
        {    number: '7b',
             content: '7b3-4, 5-6 and 7-10 students only: students with special needs who would experience difficulty completing the challenge at their grade-appropriate level can take part in the 3-10 Challenge. Students on the 3-10 Challenge level will complete the challenge by reading 20 books from any challenge level (including K-2) with whatever levels of support are appropriate to their needs. See your PRC coordinator for help with this.'
        },
        {    number: '7c',
             content: 'For all students: students who experience difficulty completing the challenge due to circumstances outside their control should talk to their PRC coordinator for assistance. PRC coordinators can provide school-based supports and adjustments to meet the needs of their school community as appropriate, and can contact the PRC team for assistance as needed.'
        },
        {
            number: '8',
            content: '3-4, 5-6, 7-10 students only - If your teacher thinks you need extra help, you can listen to unabridged audio versions of the books as long as you read along.'
        },
        {
            number: '9',
            content: 'If you complete your online Student Reading Record Friday 18 September 2026, and it is validated by your school by 25 September (11:59 pm), you will be eligible for a PRC certificate in Term 4.'
        },
        {
            number: '10',
            content: 'The certificates you can receive for completing the Challenge are:'
        },
        {
            number: '11a',
            content: 'You can only receive one certificate each year.'
        },
        {
            number: '11b',
            content: 'The PRC Medal is awarded to Year 9 and 10 students to recognise 7 years of independent reading. Year 9 are eligible for a medal for completing the Challenge every year from Year 3 - Year 9 inclusive. Year 10 students are eligible for a medal for completing the Challenge 7 times between Year 3 and Year 10. Participation in the 3-10 Challenge does not impact a student\'s ability to receive a medal.  Students will only receive a medal once - either in Year 9 or Year 10.'
        },
        {
            number: '12',
            content: 'Gold and Platinum certificates will be sent to your school in Term 4 with students\' names printed, along with PRC medals. Your school is responsible for downloading and printing your Challenge Completion Certificate from the PRC website.Your school may also choose to engrave medals with students’ names. The PRC does not engrave student medals.'
        },
        {
            number: '13',
            content: 'Your school needs to make sure your parent or carer knows that by entering the Challenge, you may receive a PRC certificate with your name and school printed. The Premier\'s Reading Challenge no longer lists student names on an Honour Roll, however there may be opportunities for students to be recognised through media publications or through the school\'s own newsletters and communications. No student names and/or details will be published publicly without prior consent from parents/ carers.'
        },
        {
            number: '14a',
            content: 'If you attend a NSW school and your school does not have a PRC coordinator and does not wish to participate in the Challenge, you can take part as an independent student. Your Challenge participation will be managed by the PRC team. You must inform the PRC team of your completion of the challenge by Friday 18 September 2026  so that your record can be validated.'
        },

    {

      number: '14b',
      content: (
    <>
            If you are home schooled, you can participate in the PRC once registered with the NSW Education Standards Authority (NESA) or granted an exemption from registration. You must{' '}
            <a href="https://artsunit.nsw.edu.au/program/nsw-premiers-reading-challenge/support/home-school-registration" target="_blank" rel="noopener noreferrer">
            register
            </a>{' '}
            with the PRC before 31 July.
    </>
      )
    },
    ],
    bookRules: {
        'K-2': {level: 'K-2', mustRead: '30', prcBooks: '20', maxChoice: '10', prcList: 'K-2, 3-4, 5-6'},
        '3-4': {level: '3-4', mustRead: '20', prcBooks: '10', maxChoice: '10', prcList: '3-4, 5-6, 7-9'},
        '5-6': {level: '5-6', mustRead: '20', prcBooks: '10', maxChoice: '10', prcList: '3-4,5-6, 7-9'},
        '7-10': {level: '7-10', mustRead: '20', prcBooks: '10', maxChoice: '10', prcList: '5-6, 7-9, 9plus'},
        '3-10': {level: '3-10', mustRead: '20', prcBooks: '10', maxChoice: '10', prcList: 'All booklists'},
    },

    cerRules: [
        {year: 'First year', awards: 'Challenge completion certificate'},
        {year: 'Second year', awards: 'Challenge completion certificate'},
        {year: 'Third year', awards: 'Challenge completion certificate'},
        {year: 'Fourth year', awards: 'Gold certificate'},
        {year: 'Fifth year', awards: 'Challenge completion certificate'},
        {year: 'Sixth year', awards: 'Challenge completion certificate'},
        {year: 'Seventh year', awards: 'Platinum certificate'},
        {year: 'Eighth year', awards: 'Challenge completion certificate'},
        {year: 'Ninth year', awards: 'Challenge completion certificate'},
        {year: 'Tenth year', awards: 'Challenge completion certificate'},
        {year: 'Only Year 9/10 students eligible (see rule 11b below) ' +
                'Year 9: Every year from Year 3 to Year 9 (inclusive) OR ' +
                'Year 10: 7 Years of completion between Year 3 – Year 10.', awards: 'Medal and Challenge completion certificate'},
    ]
}

class RulesPage extends Component {
    static propTypes = {
        changeSearchStatus: PropTypes.func.isRequired,
        isLoggedIn: PropTypes.bool.isRequired,
        changeProfileTabValue: PropTypes.func.isRequired,
    };

    componentDidMount(){
        this.props.changeSearchStatus('reset')
    }

    state = {
        tabValue: 'K-2',
        tabData: rulesData.bookRules['K-2']
    };

    handleChange = (event, value) => {

        this.setState({
            tabValue: value,
            tabData: rulesData.bookRules[value]
        });
    };

    renderRules = (from, to) => {
        let rules = [];
        for (let i = (from - 1); i < to; i++) { //as js array zero-based, so rules[0] is the first rule
            rules.push(
                <li key={i}>
                    <span className="rulesPage__rules--bullet">{rulesData.rules[i].number}</span>
                    <span className="rulesPage__rules--content">{rulesData.rules[i].content}</span>
                </li>
            );
        }
        return <ul className="rulesPage__rules--list">{rules}</ul>
    }

    renderAwardTable = () => {
        const tableData = rulesData.cerRules.map((r, i) => {
            return <TableRow key={i}>
                <TableCell>{r.year}</TableCell>
                <TableCell className="table--awardsCol">{r.awards}</TableCell>
            </TableRow>
        });
        return  <div className="rulesPage__table">
            <Paper>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Year of completing PRC</TableCell>
                            <TableCell>Award received</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableData}
                    </TableBody>
                </Table>
            </Paper>
        </div>
    }

    renderBookRulesTab = () => {
        const {
            tabValue,
            tabData
        } = this.state

        return  <div className="rulesPage__tabs">
                    <AppBar position="static" color="default">
                        <Paper>
                            <Tabs
                                value={tabValue}
                                onChange={this.handleChange}
                                indicatorColor="primary"
                                textColor="primary"
                                fullWidth>
                                <Tab className="readings__tabs--headerButton" disableRipple value="K-2" label="K-2"/>
                                <Tab className="readings__tabs--headerButton" disableRipple value="3-4" label="3-4"/>
                                <Tab className="readings__tabs--headerButton" disableRipple value="5-6" label="5-6"/>
                                <Tab className="readings__tabs--headerButton" disableRipple value="7-10" label="7-10"/>
                                <Tab className="readings__tabs--headerButton" disableRipple value="3-10" label="3-10 (refer to rule 7b)"/>
                            </Tabs>
                        </Paper>
                    </AppBar>
                    <Paper>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell>Number of Books you must read</TableCell>
                                    <TableCell className="tabs--number" numeric>{tabData.mustRead}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Minimum number of PRC books</TableCell>
                                    <TableCell className="tabs--number" numeric>{tabData.prcBooks}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Maximum number of Personal Choice books</TableCell>
                                    <TableCell className="tabs--number" numeric>{tabData.maxChoice}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>PRC booklists you can read from</TableCell>
                                    <TableCell className="tabs--number--small" numeric>{tabData.prcList}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Paper>
            Please refer to the Booklists page for more information.
                 </div>
    }

    render () {
        return (
            <div id="rulesMain">
                <Helmet>
                    <title>Rules Page: NSW Premier's Reading Challenge</title>
                    <meta name="description" content="Rules page"/>
                </Helmet>
                <ErrorBoundary>
                <div className="rulesPage">
                    <div className="rulesPage__guide">
                        <img className="rulesPage__guide--topImage" src={GuideTopImgSrc} alt=""/>
                        <div className="rulesPage__guide--conent">
                            <h2 className="rulesPage__guide--title">How to use this website</h2>
                            <p>1 <Link to="/">Discover books to read</Link></p>
                            <p>2 <BookmarkBorderIcon />{
                                this.props.isLoggedIn ?
                                <Link to="/profile" onClick={() => this.props.changeProfileTabValue(0)}> Save Book</Link> :
                                <a href="/prc/logon.html">Save Book</a>
                            }
                                = books you want to read. </p>
                            <div className="rulesPage__guide--talkBubble tri-right">
                                <div className="rulesPage__guide--talktext">
                                    <p>Use your 'Saved books' to pick books from
                                        the PRC list at a library near you </p>
                                </div>
                                <img className="rulesPage--talkBubbleImage--right" src={DialogDecorationImgSrc} alt=""/>
                            </div>
                            <p>3  {
                                this.props.isLoggedIn ?
                                    <Link to="/profile" onClick={() => this.props.changeProfileTabValue(1)}>Add to Reading log</Link> :
                                    <a href="/prc/logon.html">Add to Reading log</a>
                                }
                                <span>= books you've read for the challenge.</span></p>
                            <div className="rulesPage__guide--talkBubble tri-left">
                                <div className="rulesPage__guide--talktext">
                                    <p>Use your reading log to record books you've finished reading for
                                        this year's challenge
                                    </p>
                                </div>
                                <img className="rulesPage--talkBubbleImage--left" src={DialogDecorationImgSrc} alt=""/>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div className="rulesPage__rules">
                        <div className="rulesPage__rules--title">
                            <img className="rulesPage--rulesImage" src={BookImgSrc} alt=""/>
                            <h2>2026 Challenge rules</h2>
                        </div>


                        {this.renderRules(1, 2)}
                        {this.renderBookRulesTab()}
                        {this.renderRules(3, 14)}
                        {this.renderAwardTable()}
                        {this.renderRules(15, 20)}
                    </div>
                </div>
                </ErrorBoundary>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isLoggedIn: !!get(state, 'student.studentDetails.studentId'),
    };
}

const mapDispatchToProps = dispatch => bindActionCreators({
    changeSearchStatus,
    changeProfileTabValue
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(RulesPage);
